

export const frontMatter = {
	custom_edit_url: '/501',
	last_update: {
		author: 'Google Translate'
	},
	origin: 'http://steen.free.fr/interslavic/numbers_1-10.html'
};
export const contentTitle = 'Brojevi 1-10 u slavenskim jezicima';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-hr-docusaurus-plugin-content-docs-current-learn-misc-numbers-1-10-md-cf4.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Prirodni slavenski jezici",
  "id": "prirodni-slavenski-jezici",
  "level": 2
}, {
  "value": "Konstruirao slavenske pomoćne jezike",
  "id": "konstruirao-slavenske-pomoćne-jezike",
  "level": 2
}, {
  "value": "Izmišljeni sjevernoslavenski jezici",
  "id": "izmišljeni-sjevernoslavenski-jezici",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    h2: "h2",
    header: "header",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "brojevi-1-10-u-slavenskim-jezicima",
        children: "Brojevi 1-10 u slavenskim jezicima"
      })
    }), "\n", _jsx(_components.h2, {
      id: "prirodni-slavenski-jezici",
      children: "Prirodni slavenski jezici"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Jezik"
          }), _jsx(_components.th, {
            children: "1"
          }), _jsx(_components.th, {
            children: "2"
          }), _jsx(_components.th, {
            children: "3"
          }), _jsx(_components.th, {
            children: "4"
          }), _jsx(_components.th, {
            children: "5"
          }), _jsx(_components.th, {
            children: "6"
          }), _jsx(_components.th, {
            children: "7"
          }), _jsx(_components.th, {
            children: "8"
          }), _jsx(_components.th, {
            children: "9"
          }), _jsx(_components.th, {
            children: "10"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "praslavenski"
          }), _jsx(_components.td, {
            children: "jedini"
          }), _jsx(_components.td, {
            children: "dŭva"
          }), _jsx(_components.td, {
            children: "triĭje"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "staroslavenski"
          }), _jsx(_components.td, {
            children: "ѥdynʺ"
          }), _jsx(_components.td, {
            children: "pilana"
          }), _jsx(_components.td, {
            children: "triḱ"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pѧt"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "djevojka"
          }), _jsx(_components.td, {
            children: "desѧt"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "starovgorodski"
          }), _jsx(_components.td, {
            children: "jedan pilana"
          }), _jsx(_components.td, {
            children: "tri (ѥ)"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pѧt"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "djevojka"
          }), _jsx(_components.td, {
            children: "desѧt"
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "staroruski"
          }), _jsx(_components.td, {
            children: "jedan pilana"
          }), _jsx(_components.td, {
            children: "triḱ"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pѧt"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "djevojka"
          }), _jsx(_components.td, {
            children: "desѧt"
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "ruski"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "bjeloruski"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Podlach"
          }), _jsx(_components.td, {
            children: "odin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "pokušati"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "ja sam"
          }), _jsx(_components.td, {
            children: "zračnim putem"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "ukrajinski"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sim"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Rusin"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "svima"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Hucul"
          }), _jsx(_components.td, {
            children: "oden"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "şterǐ"
          }), _jsx(_components.td, {
            children: "pǐechǐ"
          }), _jsx(_components.td, {
            children: "şîschǐ"
          }), _jsx(_components.td, {
            children: "sim"
          }), _jsx(_components.td, {
            children: "posjetim"
          }), _jsx(_components.td, {
            children: "deawichǐ"
          }), _jsx(_components.td, {
            children: "deasichǐ"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "lemko-rusin"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "igle, igle"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "škriljevac"
          }), _jsx(_components.td, {
            children: "sim"
          }), _jsx(_components.td, {
            children: "osam, osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "šleski"
          }), _jsx(_components.td, {
            children: "samo"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "pjyńć"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "po sedam"
          }), _jsx(_components.td, {
            children: "uoźym"
          }), _jsx(_components.td, {
            children: "dźewjyńć"
          }), _jsx(_components.td, {
            children: "dźeśyńć"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "engleski"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "kašupski"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "probuditi se"
          }), _jsx(_components.td, {
            children: "sztre"
          }), _jsx(_components.td, {
            children: "piãc"
          }), _jsx(_components.td, {
            children: "szesc"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "čak ni"
          }), _jsx(_components.td, {
            children: "dzewiãc"
          }), _jsx(_components.td, {
            children: "dzesãc"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "polabski"
          }), _jsx(_components.td, {
            children: "bok"
          }), _jsx(_components.td, {
            children: "gluh"
          }), _jsx(_components.td, {
            children: "suza"
          }), _jsx(_components.td, {
            children: "citirati"
          }), _jsx(_components.td, {
            children: "påt"
          }), _jsx(_components.td, {
            children: "posljednji"
          }), _jsx(_components.td, {
            children: "sidĕm"
          }), _jsx(_components.td, {
            children: "visĕm"
          }), _jsx(_components.td, {
            children: "divāt"
          }), _jsx(_components.td, {
            children: "disąt"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "donjolužičkosrpski"
          }), _jsx(_components.td, {
            children: "jaden"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tśi"
          }), _jsx(_components.td, {
            children: "stiri"
          }), _jsx(_components.td, {
            children: "pěś"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sjedim"
          }), _jsx(_components.td, {
            children: "osmi"
          }), _jsx(_components.td, {
            children: "daeee"
          }), _jsx(_components.td, {
            children: "ti si"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "gornjolužički"
          }), _jsx(_components.td, {
            children: "samo"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "peći"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sydom"
          }), _jsx(_components.td, {
            children: "wosom"
          }), _jsx(_components.td, {
            children: "dźewjeć"
          }), _jsx(_components.td, {
            children: "dźesać"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "češki"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "slovački"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "slovenski"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Kajkavian Croatian"
          }), _jsx(_components.td, {
            children: "jeden"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedem"
          }), _jsx(_components.td, {
            children: "osem"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Čakavski hrvatski"
          }), _jsx(_components.td, {
            children: "žene"
          }), _jsx(_components.td, {
            children: "duy"
          }), _jsx(_components.td, {
            children: "tara"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "limuzina"
          }), _jsx(_components.td, {
            children: "ošan"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Croatian/Bosnian"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "srpski"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "makedonski"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "bugarski"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "ruski"
          }), _jsx(_components.td, {
            children: "odin"
          }), _jsx(_components.td, {
            children: "tva"
          }), _jsx(_components.td, {
            children: "tri sheteri"
          }), _jsx(_components.td, {
            children: "pjôet"
          }), _jsx(_components.td, {
            children: "sêst"
          }), _jsx(_components.td, {
            children: "sêm"
          }), _jsx(_components.td, {
            children: "vôsom"
          }), _jsx(_components.td, {
            children: "bogat"
          }), _jsx(_components.td, {
            children: "nedostatak"
          }), _jsx(_components.td, {})]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "konstruirao-slavenske-pomoćne-jezike",
      children: "Konstruirao slavenske pomoćne jezike"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Jezik"
          }), _jsx(_components.th, {
            children: "1"
          }), _jsx(_components.th, {
            children: "2"
          }), _jsx(_components.th, {
            children: "3"
          }), _jsx(_components.th, {
            children: "4"
          }), _jsx(_components.th, {
            children: "5"
          }), _jsx(_components.th, {
            children: "6"
          }), _jsx(_components.th, {
            children: "7"
          }), _jsx(_components.th, {
            children: "8"
          }), _jsx(_components.th, {
            children: "9"
          }), _jsx(_components.th, {
            children: "10"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "ruski jezik (Križanić)"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Sveslavenski jezik (ban)"
          }), _jsx(_components.td, {
            children: "jedini"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pjat"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Vsjeslovianskyʹ (Bambas)"
          }), _jsx(_components.td, {
            children: "jedini"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "dievjat"
          }), _jsx(_components.td, {
            children: "diejat"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Uzajemni Pravopis Slavjanski (Magyar)"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedmi"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Neuslawisch (Hošek)"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pjat"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Občeslovjanski (Hošek)"
          }), _jsx(_components.td, {
            children: "odin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šestj"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Slavina (finale)"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tre"
          }), _jsx(_components.td, {
            children: "crno"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Slavenski (Kolkop)"
          }), _jsx(_components.td, {
            children: "prvi"
          }), _jsx(_components.td, {
            children: "vter"
          }), _jsx(_components.td, {
            children: "tretirati"
          }), _jsx(_components.td, {
            children: "četvrtina"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "ſix"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Slavski (Holý)"
          }), _jsx(_components.td, {
            children: "en"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četir"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedm"
          }), _jsx(_components.td, {
            children: "osm"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Slovan (Zidek)"
          }), _jsx(_components.td, {
            children: "edna"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "chtor"
          }), _jsx(_components.td, {
            children: "piat"
          }), _jsx(_components.td, {
            children: "šesti"
          }), _jsx(_components.td, {
            children: "sodom"
          }), _jsx(_components.td, {
            children: "osum"
          }), _jsx(_components.td, {
            children: "davet"
          }), _jsx(_components.td, {
            children: "dasot"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Međunarodni jazik"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Slovio, Ruslavsk"
          }), _jsx(_components.td, {
            children: "din"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "cxtir"
          }), _jsx(_components.td, {
            children: "piat"
          }), _jsx(_components.td, {
            children: "sxes"
          }), _jsx(_components.td, {
            children: "siem"
          }), _jsx(_components.td, {
            children: "vos"
          }), _jsx(_components.td, {
            children: "razvoj"
          }), _jsx(_components.td, {
            children: "des"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Riječ"
          }), _jsx(_components.td, {
            children: "jedini"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "glagoljica"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Proslava"
          }), _jsx(_components.td, {
            children: "edin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četri"
          }), _jsx(_components.td, {
            children: "maziti"
          }), _jsx(_components.td, {
            children: "shest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osem"
          }), _jsx(_components.td, {
            children: "devat"
          }), _jsx(_components.td, {
            children: "desat"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Panslavien"
          }), _jsx(_components.td, {
            children: "edin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "qetiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "xest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osem"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Medjazik (Slavonske jazik)"
          }), _jsx(_components.td, {
            children: "jedin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "c'etiri"
          }), _jsx(_components.td, {
            children: "pjet"
          }), _jsx(_components.td, {
            children: "s'est"
          }), _jsx(_components.td, {
            children: "sedem"
          }), _jsx(_components.td, {
            children: "osem"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "slovenski"
          }), _jsx(_components.td, {
            children: "en"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "s'tir"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "s'es"
          }), _jsx(_components.td, {
            children: "ovdje"
          }), _jsx(_components.td, {
            children: "os"
          }), _jsx(_components.td, {
            children: "razvoj"
          }), _jsx(_components.td, {
            children: "des"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Slavjanski"
          }), _jsx(_components.td, {
            children: "jedini"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Slavenen (Noven Slovio)"
          }), _jsx(_components.td, {
            children: "edin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "cetir"
          }), _jsx(_components.td, {
            children: "pent"
          }), _jsx(_components.td, {
            children: "xest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osem"
          }), _jsx(_components.td, {
            children: "nevent"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Slovioski"
          }), _jsx(_components.td, {
            children: "jedin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "piat"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedem"
          }), _jsx(_components.td, {
            children: "osm"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "slavenski jezik"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "osim"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Novoslovenskij"
          }), _jsx(_components.td, {
            children: "samac"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Obrazovni Medžuslovjanski"
          }), _jsx(_components.td, {
            children: "jedini"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Slovianto"
          }), _jsx(_components.td, {
            children: "jedin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedem"
          }), _jsx(_components.td, {
            children: "osm"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Prostoslovjanski"
          }), _jsx(_components.td, {
            children: "jedin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedem"
          }), _jsx(_components.td, {
            children: "osem"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Rusanto"
          }), _jsx(_components.td, {
            children: "Odin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "cxetire"
          }), _jsx(_components.td, {
            children: "piat"
          }), _jsx(_components.td, {
            children: "sxest"
          }), _jsx(_components.td, {
            children: "sem"
          }), _jsx(_components.td, {
            children: "sve"
          }), _jsx(_components.td, {
            children: "odstupiti"
          }), _jsx(_components.td, {
            children: "desiti"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "slovački"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dvi"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "chotiri"
          }), _jsx(_components.td, {
            children: "peti"
          }), _jsx(_components.td, {
            children: "shesti"
          }), _jsx(_components.td, {
            children: "sedmi"
          }), _jsx(_components.td, {
            children: "osjedmi"
          }), _jsx(_components.td, {
            children: "deveti"
          }), _jsx(_components.td, {
            children: "deseti"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "venecijanski"
          }), _jsx(_components.td, {
            children: "jesti"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Nowoslownica"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Slovenska nova lingvafranka (SNL)"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "czeter"
          }), _jsx(_components.td, {
            children: "ljubimac"
          }), _jsx(_components.td, {
            children: "szest"
          }), _jsx(_components.td, {
            children: "sedem"
          }), _jsx(_components.td, {
            children: "vose"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "izmišljeni-sjevernoslavenski-jezici",
      children: "Izmišljeni sjevernoslavenski jezici"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Jezik"
          }), _jsx(_components.th, {
            children: "1"
          }), _jsx(_components.th, {
            children: "2"
          }), _jsx(_components.th, {
            children: "3"
          }), _jsx(_components.th, {
            children: "4"
          }), _jsx(_components.th, {
            children: "5"
          }), _jsx(_components.th, {
            children: "6"
          }), _jsx(_components.th, {
            children: "7"
          }), _jsx(_components.th, {
            children: "8"
          }), _jsx(_components.th, {
            children: "9"
          }), _jsx(_components.th, {
            children: "10"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Sevorian"
          }), _jsx(_components.td, {
            children: "iedøn"
          }), _jsx(_components.td, {
            children: "dvaa"
          }), _jsx(_components.td, {
            children: "trii"
          }), _jsx(_components.td, {
            children: "sxøtir"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "sxest"
          }), _jsx(_components.td, {
            children: "sedøm"
          }), _jsx(_components.td, {
            children: "osøm"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Vozgian (Gŭor vŭozgaschai)"
          }), _jsx(_components.td, {
            children: "íđín"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "ćrí"
          }), _jsx(_components.td, {
            children: "chadir"
          }), _jsx(_components.td, {
            children: "penć"
          }), _jsx(_components.td, {
            children: "šeć"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "dëenć"
          }), _jsx(_components.td, {
            children: "desno"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Našica (stara)"
          }), _jsx(_components.td, {
            children: "edët"
          }), _jsx(_components.td, {
            children: "deva"
          }), _jsx(_components.td, {
            children: "pokušati"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Nasika (novo)"
          }), _jsx(_components.td, {
            children: "inu"
          }), _jsx(_components.td, {
            children: "ta"
          }), _jsx(_components.td, {
            children: "tiirä"
          }), _jsx(_components.td, {
            children: "ptica"
          }), _jsx(_components.td, {
            children: "pedeset"
          }), _jsx(_components.td, {
            children: "da"
          }), _jsx(_components.td, {
            children: "settomi"
          }), _jsx(_components.td, {
            children: "stoma"
          }), _jsx(_components.td, {
            children: "tinejdžer"
          }), _jsx(_components.td, {
            children: "tesemti"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Seversk"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tre"
          }), _jsx(_components.td, {
            children: "štåre"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Mrezisk"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "deva"
          }), _jsx(_components.td, {
            children: "tera"
          }), _jsx(_components.td, {
            children: "štara"
          }), _jsx(_components.td, {
            children: "pynta"
          }), _jsx(_components.td, {
            children: "šasta"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "desat"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Proslavljen"
          }), _jsx(_components.td, {
            children: "gadan"
          }), _jsx(_components.td, {
            children: "deva"
          }), _jsx(_components.td, {
            children: "pogoni"
          }), _jsx(_components.td, {
            children: "šator"
          }), _jsx(_components.td, {
            children: "pinta"
          }), _jsx(_components.td, {
            children: "shasta"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "osam"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Slavisk"
          }), _jsx(_components.td, {
            children: "u njegovoj kući"
          }), _jsx(_components.td, {
            children: "deva"
          }), _jsx(_components.td, {
            children: "tera"
          }), _jsx(_components.td, {
            children: "štara"
          }), _jsx(_components.td, {
            children: "pinta"
          }), _jsx(_components.td, {
            children: "šašta"
          }), _jsx(_components.td, {
            children: "sedam"
          }), _jsx(_components.td, {
            children: "moj stari"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "désat"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Ijslova"
          }), _jsx(_components.td, {
            children: "jijn"
          }), _jsx(_components.td, {
            children: "dvis"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "sjöris"
          }), _jsx(_components.td, {
            children: "pjem"
          }), _jsx(_components.td, {
            children: "ona"
          }), _jsx(_components.td, {
            children: "sjödem"
          }), _jsx(_components.td, {
            children: "ästem"
          }), _jsx(_components.td, {
            children: "snijeg disam"
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Škoda"
          }), _jsx(_components.td, {
            children: "jerino"
          }), _jsx(_components.td, {
            children: "dova"
          }), _jsx(_components.td, {
            children: "trije"
          }), _jsx(_components.td, {
            children: "t'ietiiri"
          }), _jsx(_components.td, {
            children: "mali"
          }), _jsx(_components.td, {
            children: "siete"
          }), _jsx(_components.td, {
            children: "uosme"
          }), _jsx(_components.td, {
            children: "dieviente"
          }), _jsx(_components.td, {
            children: "diesiente"
          }), _jsx(_components.td, {
            children: "-"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Novegradski"
          }), _jsx(_components.td, {
            children: "jedan"
          }), _jsx(_components.td, {
            children: "dua"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četiri"
          }), _jsx(_components.td, {
            children: "peti"
          }), _jsx(_components.td, {
            children: "šesti"
          }), _jsx(_components.td, {
            children: "shenyi"
          }), _jsx(_components.td, {
            children: "osmi"
          }), _jsx(_components.td, {
            children: "deveti"
          }), _jsx(_components.td, {
            children: "dogoditi se"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Onegian (Onegskoi ezeik)"
          }), _jsx(_components.td, {
            children: "edin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "tri"
          }), _jsx(_components.td, {
            children: "četeire"
          }), _jsx(_components.td, {
            children: "pet"
          }), _jsx(_components.td, {
            children: "šest"
          }), _jsx(_components.td, {
            children: "sedem"
          }), _jsx(_components.td, {
            children: "osem"
          }), _jsx(_components.td, {
            children: "devet"
          }), _jsx(_components.td, {
            children: "deset"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Rothian (Isus Krist)"
          }), _jsx(_components.td, {
            children: "jödin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "Tri"
          }), _jsx(_components.td, {
            children: "ššetüri"
          }), _jsx(_components.td, {
            children: "-"
          }), _jsx(_components.td, {
            children: "-"
          }), _jsx(_components.td, {
            children: "-"
          }), _jsx(_components.td, {
            children: "-"
          }), _jsx(_components.td, {
            children: "-"
          }), _jsx(_components.td, {
            children: "-"
          })]
        })]
      })]
    }), "\n", "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

